import styled from '@emotion/styled';
import { Col } from 'antd';
import { appStyles, defaultImage, formScrolling, selectSelector } from '../../../../styles';

export const StyledForm = styled(Col)`
  padding: 0.5rem 0.5rem 0 1rem;
  height: 570px;

  ${formScrolling}
  ${selectSelector}

  & input[type='text'],
  & input[type='number'] {
    ${appStyles.inputStyle}
  }
  & .ant-form-item-label {
    font-weight: bold;
    font-size: 16px;
  }
  & button.btn-submit-form-home {
    $${appStyles.commonButtonSubmitted}
  }
  & .ant-form-item {
    margin-bottom: 0.2rem;
  }

  & .ant-input-group-addon {
    ${appStyles.background.black}
  }

  & .ctaLinkPromotion .ant-input-group-addon {
    ${appStyles.background.modalBgGray}
  }

  .ant-upload.ant-upload-select-picture-card {
    width: 36px;
    height: 36px;
    margin-right: 0;
    margin-bottom: 0;
    border: none;
  }

  .UploadImage {
    background: #000;
    & > span {
      vertical-align: baseline;
    }
  }

  .ant-input-affix-wrapper {
    padding: 0 0 0 11px;
    border-radius: 4px;
  }

  .ant-upload-list-text {
    position: absolute;
    left: 0;
    & .ant-upload-list-item {
      background: #efefef;
    }
    & .ant-upload-list-text-container {
      transition: none;
    }
  }

  .fileName-bgImage-hidden .ant-upload-list-text {
    display: none;
    transition: none;
  }

  .image-backgroundImage {
    margin-bottom: 24px;
  }

  & .buttonLink {
    .ant-form-item-required::before {
      color: transparent !important;
    }
  }
`;

export const StyledPreview = styled(Col)`
  background: transparent linear-gradient(180deg, #dedede00 0%, #7e7e7e 100%) 0% 0% no-repeat padding-box;
  ${defaultImage}

  & .Preview-JustIn {
    & .button {
      background: transparent linear-gradient(180deg, #0000004a 50%, #0000004a 50%) !important;
      color: #fff !important;
      border: 1px solid #fff !important;
    }

    & .wrapper-text-preview {
      bottom: 20% !important;
    }
  }
`;
